import { h } from 'preact';
import * as styles from './search-field.scss';
import { InputField } from '@playkit-js/common/dist/components/input-field';
import { withText, Text } from 'preact-i18n';

const translations = ({ searchResultsCount, currentSearchIndex }: Pick<Props, 'searchResultsCount' | 'currentSearchIndex'>) => ({
  searchInputPlaceholder: <Text id="taxonomyTranscript.search.placeholder">Search in transcript</Text>,
  clearTextLabel: <Text id="taxonomyTranscript.search.clear">Clear search</Text>,
  nextMatchLabel: <Text id="taxonomyTranscript.search.nextMatch">Next match</Text>,
  previousMatchLabel: <Text id="taxonomyTranscript.search.previousMatch">Previous match</Text>,
  searchResultsLabel: (
    <Text
      fields={{
        current: searchResultsCount > 0 ? currentSearchIndex : 0,
        total: searchResultsCount
      }}
      id="taxonomyTranscript.searchResults"
    >
      {`Search result ${searchResultsCount > 0 ? currentSearchIndex : 0} out of ${searchResultsCount}`}
    </Text>
  )
});

interface Props {
  currentSearchIndex: number | null;
  searchResultsCount: number;
  searchValue: string;
  onChange: (value: string) => void;
  onSearchIndexChange: (index: number) => void;
}
export const SearchField = withText(translations)(({
  currentSearchIndex,
  searchResultsCount,
  searchValue,
  onChange,
  onSearchIndexChange,
  searchInputPlaceholder,
  clearTextLabel,
  nextMatchLabel,
  previousMatchLabel,
  searchResultsLabel
}: Props & Record<keyof ReturnType<typeof translations>, string>): h.JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <InputField
        clearSearchLabel={clearTextLabel}
        placeholder={searchInputPlaceholder}
        searchResults={{
          activeSearchIndex: currentSearchIndex ?? 0,
          totalSearchResults: searchResultsCount,
          prevMatchLabel: previousMatchLabel,
          nextMatchLabel: nextMatchLabel,
          onSearchIndexChange,
          searchResultsLabel
        }}
        value={searchValue}
        onChange={(value) => {
          onChange(value);
        }}
      />
    </div>
  );
});
